export default __webpack_public_path__ + "static/media/Q2-2.862f043a.png";